import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";
import {
  AddNewDGToSite,
  AddNewSite,
  DeleteSiteOrGroup,
} from "../../api/api"; // Adjust the import path as necessary
import { useCallback, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useAppContextProvider from "../../AppContext/useAppContextProvider";

type DGResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};

export const useDeleteSiteOrGroup = (): UseMutationResult<
  DGResult,
  Error
> => {
  const queryClient = useQueryClient();

  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();
  const mutation = useMutation({
    mutationFn: ({
      siteAndGroupList,
      token,
    }: {
      siteAndGroupList: object;
      token: string;
    }) => DeleteSiteOrGroup({ siteAndGroupList }, token),
    onSuccess: async (data) => {
      if (data.status === "error") {
        console.log("Error adding site:", data);
      } else {
        console.log("Site added successfully");
      }
    },
    onError: (error) => {
      console.error("Error adding site:", error);
    },
  });

  const mutateWithToken = useCallback(
    async (
      siteAndGroupList: object,
      options: {
        onSuccess?: (data: DGResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      } = { onSuccess: () => {}, onError: () => {} }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        {
          siteAndGroupList,
          token,
        },
        {
          onSuccess: options.onSuccess,
          onError: options.onError,
          onSettled: options.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return {
    ...mutation,
    mutate: (
      variables: { siteAndGroupList: object },
      options?: {
        onSuccess?: (data: DGResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      mutateWithToken(variables.siteAndGroupList, options);
    },
  };
};
